import { useState } from "react";

export default function ContactUs() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    message: ""
  });

  const submitForm = async (e) => {
    e.preventDefault();

    const res = await fetch("http://localhost/api/contact.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(form)
    });

    const data = await res.json();
    alert(data.message);
  };

  return (
    <div className="container py-5">
      <h2 className="gradient-text mb-4">Contact Us</h2>

      <form className="glass p-4" onSubmit={submitForm}>
        <input
          className="form-control mb-3 bg-transparent text-white"
          placeholder="Name"
          onChange={(e) => setForm({ ...form, name: e.target.value })}
        />

        <input
          className="form-control mb-3 bg-transparent text-white"
          placeholder="Email"
          onChange={(e) => setForm({ ...form, email: e.target.value })}
        />

        <textarea
          className="form-control mb-3 bg-transparent text-white"
          placeholder="Message"
          onChange={(e) => setForm({ ...form, message: e.target.value })}
        />

        <button className="btn btn-primary w-100">Send Message</button>
      </form>
    </div>
  );
}
